import { ICustomIconProps } from './types';

const IconCardEdit: React.FC<ICustomIconProps> = ({ size = 20, color = '#9F9F9F', className }) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path d='M1.66344 7.08334H9.5801' stroke={color} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M4.99677 13.75H6.66344' stroke={color} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M8.74677 13.75H12.0801' stroke={color} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M18.3301 10.025V13.425C18.3301 16.35 17.5884 17.0833 14.6301 17.0833H5.36344C2.4051 17.0833 1.66344 16.35 1.66344 13.425V6.57499C1.66344 3.64999 2.4051 2.91666 5.36344 2.91666H12.0801'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.8968 3.44166L12.8051 6.53332C12.6884 6.64999 12.5718 6.88332 12.5468 7.04999L12.3801 8.23332C12.3218 8.65832 12.6218 8.95832 13.0468 8.89999L14.2301 8.73332C14.3968 8.70832 14.6301 8.59166 14.7468 8.47499L17.8384 5.38332C18.3718 4.84999 18.6218 4.23332 17.8384 3.44999C17.0468 2.65832 16.4301 2.90832 15.8968 3.44166Z'
      stroke={color}
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.4551 3.88333C15.7218 4.825 16.4551 5.55833 17.3884 5.81666'
      stroke={color}
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default IconCardEdit;
